"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Facebook, Instagram, Twitter } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6 justify-center">
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false} className="mx-auto">
      <NavigationMenuList className="flex-wrap justify-center gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <footer id="footer" ref={ref} className={`bg-background py-16 border-t border-border transition-opacity duration-200 ease-out ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container max-w-4xl mx-auto px-6">
        <div className="flex flex-col items-center gap-8">
          <Link to="/" className="block">
            <img src="https://markjohnstonmotors.ie/wp-content/uploads/2026/02/Automotive-Repair-Shop-Servicing-and-repairs-of-all-makes-of-cars-and-light-commercial-vehicles-Full-diagnostics-NCT-repairs-NCT-checks-Tyres-and-puncture-repairs-1-scaled.png" alt="Mark Johnston Motors Ltd." className="!w-[500px] !h-[500px]" />
          </Link>

          <MenuProvider menu_id="33" className="w-full">
            <FooterMenuConsumer />
          </MenuProvider>

          <div className="flex items-center gap-6">
            <Link to="https://facebook.com" newTab className="text-muted-foreground hover:text-foreground transition-all duration-200 hover:scale-110" aria-label="Facebook">
              <Facebook className="size-5" strokeWidth={1.5} />
            </Link>
            <Link to="https://instagram.com" newTab className="text-muted-foreground hover:text-foreground transition-all duration-200 hover:scale-110" aria-label="Instagram">
              <Instagram className="size-5" strokeWidth={1.5} />
            </Link>
            <Link to="https://twitter.com" newTab className="text-muted-foreground hover:text-foreground transition-all duration-200 hover:scale-110" aria-label="Twitter">
              <Twitter className="size-5" strokeWidth={1.5} />
            </Link>
          </div>

          <p className="text-sm text-muted-foreground text-center">© 2026 Mark Johnston Motors Ltd. All rights reserved. Website built by Know How Media Agency.&nbsp;</p>
        </div>
      </div>
    </footer>;
}